AgrimarketControllers.controller('userContractsV2FixedController', ['$scope', '$rootScope', 'contractsService', 'cropsService', '$sce', 'columns',
    function ($scope, $rootScope, contractsService, cropsService, $sce, columns) {

        var Init = function () {
            // Contrats fixés
            $scope.tableDataVisible = columns.data.DataVisible.split(',');
            $scope.tableLibelle = columns.data.ColumnName.split(',');

            // Gestion du trie
            $scope.reverse = true;
            $scope.sortKey = "IdContractCommitment";
            $scope.pageNo = 1;
            $scope.max = 10;

            $scope.currentView = "Fixed";
            $scope.idProductSelected = "";
            $scope.idCropSelected = $rootScope.crop.IdCrop;
            $scope.idTypeOrderSelected = "";
            $scope.dateSelected = "";

            GetContracts();
        };

        $scope.$watch("selectedIdContract", function (newValue, oldValue) {
            if ((newValue && oldValue !== newValue) || (!newValue && oldValue))
                $scope.GetContractsWithFilter();
        });

        $scope.$watch("dateFilter", function (newValue, oldValue) {
            if ((newValue && oldValue !== newValue) || (!newValue && oldValue))
                $scope.GetContractsWithFilter();
        });

        $scope.$watch("dateSelected", function (newValue) {
            if (newValue === "")
                $scope.dateFilter = "";
            else if (newValue) {
                //permet de gérer l'internalisation de tout les formats des dates possibles.
                //Au final nous faisons en sorte de la retrouvé au format dd/mm/yyyy.
                var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                var dt = new Date(newValue.replace(pattern, '$3-$2-$1'));
                var currentDate = new Date(dt.toString());
                var converDate = moment(currentDate);
                $scope.dateFilter = converDate.format('YYYY/MM/DD');
            }
        });

        var GetFiltersWithContracts = function () {
            $scope.loading = true;
            $scope.idProductSelected = "";
            $scope.idTypeOrderSelected = "";
            $scope.selectedIdContract = "";
            $scope.dateSelected = "";
            $scope.All = $rootScope.editableObjectsFactory.EditableObjects.All.Content;
            contractsService.GetFiltersForUserContractsFixedByCrop($scope.idCropSelected, function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else {
                    if (data) {
                        $scope.lstProducts = data.LstProductVm;
                        $scope.lstTypeOrders = data.LstTypeOrderVm;

                        if ($scope.lstProducts.length === 1)
                            $scope.idProductSelected = $scope.lstProducts[0].Id;
                        else if ($scope.lstProducts.length > 1)
                            $scope.lstProducts.unshift({ Id: "", Label: $scope.All });

                        if ($scope.lstTypeOrders.length === 1)
                            $scope.idTypeOrderSelected = $scope.lstTypeOrders[0].Id;
                        else if ($scope.lstTypeOrders.length > 1)
                            $scope.lstTypeOrders.unshift({ Id: "", Label: $scope.All });

                        $scope.GetContractsWithFilter();
                    }
                }
            });
        };

        var GetDefaultCrop = function (callback) {
            cropsService.GetDefaultCrop(function (data, status) {
                if (status !== null) {
                    if (status === 400)
                        $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                } else {
                    if (data !== null) {
                        $scope.idCropSelected = data.IdCrop;
                        callback();
                    }
                }
            });
        };

        var GetContracts = function () {
            if (!$scope.idCropSelected) //Si on a pas de récolte de sélectionnée on prend celle par défaut
                GetDefaultCrop(GetContracts());
            else
                GetFiltersWithContracts();
        };

        $scope.GetContractsWithFilter = function () {
            if (!$scope.selectedIdContract) $scope.selectedIdContract = "";
            $scope.loading = true;
            contractsService.GetUserContractsFixedPaginate($scope.idCropSelected, $scope.idProductSelected, $scope.selectedIdContract, $scope.idTypeOrderSelected, $scope.dateFilter, $scope.max, $scope.pageNo, $scope.sortKey, $scope.reverse, function (data, status) {
                    if (status !== null) {
                        if (status === 400)
                            $scope.errorMessage = $sce.trustAsHtml(data[0].errors[0].Message);
                    } else {
                        $scope.total = data.Total;
                        $scope.contractCommitments = data.ListVm;
                        $scope.contractCommitments.forEach(function (item) {
                            item.showDetail = true;
                        });
                        $scope.loading = false;
                    }
                });
        };

        $scope.Sort = function (sortKey, reverse) {
            $scope.sortKey = sortKey;
            $scope.reverse = reverse;
            $scope.GetContractsWithFilter();
        };

        $scope.GetData = function (pageNo) {
            $scope.pageNo = pageNo;
            $scope.GetContractsWithFilter();
        };

        $rootScope.onRefresh = function () {
            Init();
        };

        $scope.AsChangedCrop = function () {
            Init();
        };

        Init();
    }]);
